import EventsService from '@/services/api/events.services'

const state = {
    events: [],
    closeDaysOff: [],
    closeVacations: [],
    userDaysOff: [],
    userVacations: []
}

const mutations = {
    SET_CLOSE_VACATIONS(state, payload) {
        state.closeVacations = payload.map(item => {
            return Object.assign(item, {
                dayCount: Math.floor(
                    Math.abs(
                        new Date().getTime() -
                        new Date(item.start).getTime(),
                    ) /
                    (1000 * 3600 * 24),
                )
            })
        }).filter(item => item.dayCount === 0)
    },
    SET_CLOSE_DAYS_OFF(state, payload) {
        state.closeDaysOff = payload.map(item => {
            return Object.assign(item, {
                dayCount: Math.floor(
                    Math.abs(
                        new Date().getTime() -
                        new Date(item.start).getTime(),
                    ) /
                    (1000 * 3600 * 24),
                )
            })
        }).filter(item => item.dayCount === 0)
    },
    SET_USER_DAYS_OFF(state, payload) {
        state.userDaysOff = payload.map(item => {
            let loop = new Date(item.start);
            let count = 0

            while (loop <= new Date(item.end)) {
                if (loop.getDay() !== 0 && loop.getDay() !== 6) count++
                let newDate = loop.setDate(loop.getDate() + 1);
                loop = new Date(newDate);
            }

            return {
                id: item.id,
                user: item.user,
                start: item.start === null && item.end === null ? item.date : item.start,
                end: item.start === null && item.end === null ? item.date : item.end,
                date: item.date,
                created_at: item.created_at,
                active: item.active,
                without_pay: item.without_pay,
                dayCount: count
            }
        })
    },
    SET_USER_VACATIONS(state, payload) {
        state.userVacations = payload.map(item => {
            let loop = new Date(item.start);
            let count = 0

            while (loop <= new Date(item.end)) {
                if (loop.getDay() !== 0 && loop.getDay() !== 6) count++
                let newDate = loop.setDate(loop.getDate() + 1);
                loop = new Date(newDate);
            }

            return {
                id: item.id,
                user: item.user,
                start: item.start,
                created_at: item.created_at,
                end: item.end,
                date: item.date,
                active: item.active,
                without_pay: item.without_pay,
                dayCount: count

            }
        })
    }
}

const actions = {
    getCloseVacations({ commit }) {
        return new Promise((resolve, reject) => {
            EventsService.getVacations()
                .then((response) => {
                    commit('SET_CLOSE_VACATIONS', response.data.data)

                    return resolve(response)
                })
                .catch((error) => reject(error))
        })
    },
    getCloseDaysOff({ commit }) {
        return new Promise((resolve, reject) => {
            EventsService.getDayOffs()
                .then((response) => {
                    commit('SET_CLOSE_DAYS_OFF', response.data.data)

                    return resolve(response)
                })
                .catch((error) => reject(error))
        })
    },
    getUserVacations({ commit }, id) {
        return new Promise((resolve, reject) => {
            EventsService.getUserVacations(id)
                .then((response) => {
                    commit('SET_USER_VACATIONS', response.data.data)

                    return resolve(response)
                })
                .catch((error) => reject(error))
        })
    },
    getUserDaysOff({ commit }, id) {
        return new Promise((resolve, reject) => {
            EventsService.getUserDaysOff(id)
                .then((response) => {
                    commit('SET_USER_DAYS_OFF', response.data.data)

                    return resolve(response)
                })
                .catch((error) => reject(error))
        })
    },
}

const getters = {
    getVacations: (state) => state.events.filter((item) => item.vacation),
    getCloseDaysOff: (state) => state.closeDaysOff,
    getCloseVacations: (state) => state.closeVacations,
    getUserVacations: state => state.userVacations,
    getUserDaysOff: state => state.userDaysOff,
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
}
